import { z } from "zod";
export const ZMigrationRun = z.object({
    id: z.string(),
    name: z.string(),
    status: z.enum(["running", "success", "failed"]),
    startedAt: z.string(),
    finishedAt: z.string().optional(),
    startedBy: z.string(),
    startedByName: z.string().optional(),
    logs: z.array(z.string()),
    error: z.string().optional(),
});
export const ZMigration = z.object({
    name: z.string(),
    title: z.string(),
    description: z.string(),
    latestRun: ZMigrationRun.nullable(),
});
export const ZRunMigrationInput = z.object({
    name: z.string().min(1),
    allowRerun: z.boolean().default(false),
    limit: z.number().int().positive().optional(),
});
